import React, { useState } from "react";
import { Form, Container } from "semantic-ui-react";

function SearchUser(props) {
    const [query, setQuery] = useState("");
    const [error, setError] = useState(false);

    const handleChange = e => {
        setQuery(e.target.value);
        error && setError(false);
    };

    const handleClear = e => {
        e.preventDefault();
        props.onClear();
        setQuery("");
    };

    const handleSubmit = () => {
        if (query === "") {
            setError(true);
        } else {
            props.onSearch(query);
        }
    };

    return (
        <Container>
            <div className="search-container">
                <Form onSubmit={handleSubmit} size="big" className="search-form">
                    <Form.Input
                        error={
                            error && {
                                content: "Please enter a GitHub username to search",
                                pointing: "below"
                            }
                        }
                        type="text"
                        icon="search"
                        placeholder="Enter GitHub username..."
                        value={query}
                        onChange={handleChange}
                        style={{
                            borderRadius: "12px",
                            padding: "12px 16px",
                            fontSize: "16px"
                        }}
                    />
                    <Form.Button
                        fluid
                        content="Search"
                        color="blue"
                        type="submit"
                        size="large"
                        className="search-btn"
                        style={{
                            marginTop: "10px",
                            marginBottom: props.showClear ? "10px" : "0"
                        }}
                    />
                    {props.showClear && (
                        <Form.Button
                            size="large"
                            fluid
                            content="Clear Results"
                            onClick={handleClear}
                            type="button"
                            style={{
                                background: "#f5f5f5",
                                color: "#333",
                                fontWeight: "600",
                                borderRadius: "12px"
                            }}
                        />
                    )}
                </Form>
            </div>
        </Container>
    );
}
export default SearchUser;
